import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Segment } from 'semantic-ui-react';
import styled from 'styled-components';

import { LanguageSwitcher } from './LanguageSwitcher';

export const AppFooter: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Styled>
      <div className="app-footer">
        <Segment.Group>
          <Segment inverted={true} className="app-footer-menu">
            <Menu inverted={true} borderless={true}>
              <Menu.Item name="company-profile">
                <a
                  className="footer-text"
                  href={t('pages.external.corporateProfile.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.external.corporateProfile.title')}
                </a>
              </Menu.Item>
              <Menu.Item name="terms-of-use">
                <a
                  className="footer-text"
                  href={t('pages.support.termsOfUse.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.support.termsOfUse.title')}
                </a>
              </Menu.Item>
              <Menu.Item name="privacy">
                <a
                  className="footer-text"
                  href={t('pages.support.privacy.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.support.privacy.title')}
                </a>
              </Menu.Item>
              <Menu.Item name="recommended-environment">
                <a
                  className="footer-text"
                  href={t('pages.support.recommendedEnvironment.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.support.recommendedEnvironment.title')}
                </a>
              </Menu.Item>
              <Menu.Item name="faq">
                <a
                  className="footer-text"
                  href={t('pages.support.faq.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.support.faq.title')}
                </a>
              </Menu.Item>
              <Menu.Item name="inquiry">
                <a
                  className="footer-text"
                  href={t('pages.external.inquiry.url')}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {t('pages.external.inquiry.title')}
                </a>
              </Menu.Item>
              <Menu.Item
                name="language-switcher"
                className="language-switcher-menu-item"
              >
                <LanguageSwitcher />
              </Menu.Item>
            </Menu>
          </Segment>
          <Segment textAlign="center" inverted={true} className="copyright">
            © GLOBIS All Rights Reserved.
          </Segment>
        </Segment.Group>
      </div>
    </Styled>
  );
};

const Styled = styled.div`
  .app-footer {
    bottom: 0;
    width: 100%;
  }

  .app-footer > .ui.segments {
    border: none;
  }

  .app-footer > .ui.segments > .ui.inverted.segment {
    background-color: #3a3a3a;
    border-radius: 0;
  }

  .app-footer .ui.borderless.inverted.menu {
    width: 968px;
    margin: 0 auto;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    background-color: #3a3a3a;
    border-radius: 0;
  }

  .app-footer .ui.inverted.segment.app-footer-menu {
    padding: 30px 30px 21px;
  }

  .app-footer .ui.inverted.center.aligned.segment.copyright {
    padding-top: 0;
    font-size: 12px;
  }

  .app-footer .language-switcher-menu-item {
    margin-left: auto;
  }

  .app-footer img {
    display: inline-block;
    width: 18em;
    vertical-align: middle;
  }

  .app-footer .ui.text.menu {
    margin: 0;
  }

  .app-footer .footer-text {
    color: rgba(255, 255, 255, 0.9) !important;
  }

  .app-footer a.footer-text:hover {
    color: rgba(255, 255, 255, 0.75) !important;
  }

  .app-footer
    .ui.borderless.inverted.menu
    > .item:not(.language-switcher-menu-item) {
    font-size: 12px;
  }

  .app-footer
    .ui.inverted.segment.app-footer-menu
    .item.language-switcher-menu-item {
    padding: 0;
  }

  .app-footer .ui.borderless.inverted.menu {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .app-footer .ui.borderless.inverted.menu > :first-child {
    padding-left: 10px;
  }

  .app-footer .ui.inverted.center.aligned.segment.copyright {
    padding-bottom: 17px;
  }
`;
